import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getOpenAIKeyMeta, setOpenAIKey, deleteOpenAIKey } from "@/features/settings/api/openaiKey";
import { showSuccess, showErrorFromMutation } from "@/shared/utils/toast";

const QUERY_KEY = ["openai-key-meta"];

export function useOpenAIKey() {
  return useQuery({ queryKey: QUERY_KEY, queryFn: getOpenAIKeyMeta });
}

export function useSetOpenAIKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (api_key) => setOpenAIKey(api_key),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      showSuccess("OpenAI API key saved.");
    },
    onError: (err) => showErrorFromMutation(err, "Failed to save key."),
  });
}

export function useDeleteOpenAIKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteOpenAIKey,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QUERY_KEY });
      showSuccess("OpenAI API key removed.");
    },
    onError: (err) => showErrorFromMutation(err, "Failed to remove key."),
  });
}
